import {
  Component,
  inject,
  Injector,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  MSAL_GUARD_CONFIG,
  MsalBroadcastService,
  MsalGuardConfiguration,
  MsalService,
} from '@azure/msal-angular';
import { BdAuthenticationRoot } from '@bindoc-projects/security-lib/data';
import { BdMenuDevInfoButtonComponent } from '@bindoc-projects/security-lib/ui';
import { BdAuthenticationService } from '@bindoc-projects/security-lib/data';
import { BdAppContainerComponent } from '@bindoc-projects/app-container-lib/ui';
import { BdAppContainerConfig, BdAppContainerService } from '@bindoc-projects/app-container-lib/data';
import { RouterOutlet } from '@angular/router';

import { BdUserZendeskButtonComponent } from '@bindoc-projects/user-lib/ui';

import { BdAppUserMenuComponent } from '@bindoc-projects/user-lib/ui';
import { BdFeature } from '@bindoc-projects/feature-catalog-domain-lib';

@Component({
  selector: 'app-root',
  template: `
    <bd-app-container [config]="appContainerConfig" [features]="features">
      <ng-container bd-app-top-right-action>
        <div class="flex items-center gap-1">
          <bd-menu-dev-info-button />
          <bd-user-zendesk-button />
          <bd-app-user-menu [showNotifications]="false" />
        </div>
      </ng-container>
      <ng-container bd-app-content>
        @if (!isIframe) {
          <router-outlet></router-outlet>
        }
      </ng-container>
    </bd-app-container>
  `,
  styles: [],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    BdAppContainerComponent,
    BdAppUserMenuComponent,
    BdMenuDevInfoButtonComponent,
    RouterOutlet,
    BdUserZendeskButtonComponent,
  ],
})
export class AppComponent extends BdAuthenticationRoot implements OnInit {
  public readonly features: BdFeature<string>[] = [];

  public readonly appContainerConfig: BdAppContainerConfig = {
    menu: false,
  };

  private readonly _injector = inject(Injector);
  private readonly _appService = inject(BdAppContainerService);

  constructor() {
    super(
      inject(MSAL_GUARD_CONFIG) as MsalGuardConfiguration,
      inject(MsalBroadcastService),
      inject(MsalService),
      inject(BdAuthenticationService),
    );

    this._appService.setTitle('BinDoc Struktur- und Leistungsdaten Import');
  }

  ngOnInit(): void {
    this._initAuthenticationRoot(this._injector);
  }
}
